export const spaceBlacklist = [
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
];
export const alignSelfBlacklist = ['alignSelf'];
export const textAlignBlacklist = ['text-align'];
